import React from 'react'
import {FaFacebookF} from 'react-icons/fa'
import {BsTwitter} from 'react-icons/bs'
import {TfiInstagram} from 'react-icons/tfi'
import { Link } from 'react-router-dom'
 
export const Footer = () => {
  return (
    <footer className='bg-primaryblue'> 

      <div className=''>
            <div className='container  mx-auto text-[#ffffff] '> 
              <div className=' flex flex-col lg:flex-row lg:space-x-7 lg:justify-between w-full   mx-auto pl-12 lg:pl-0 pt-8'>
                <div className='lg:w-1/3'> 
                  <div className='flex items-center'>
                    <img className='h-4' src='./image/logofooter.png' alt=''/>  
                    <h1 className='ml-1 '> MSLockDown </h1>
                  </div>
                    <p className='text-base lg:text-sm'>Experience true freedom to connect and meet with people  Globally.  </p>
                </div> 

                <div className=' lg:pl-20 flex flex-col lg:flex-row lg:justify-between lg:w-full '> 
                    
                <div className=' mt-6 lg:mt-0 text-sm  sm:text-base lg:text-sm' > 
                  <h1 className='border-b-2  w-fit  '> COMPANY </h1>
                 <Link to='/about-us'> <p className='mt-2 w-fit hover:text-[#000000]  transition duration-200'> About us </p> </Link>  
                  <p className='mt-2 w-fit hover:text-[#000000] hover:cursor-pointer  transition duration-200'> Contact Us </p>
                </div>

                <div className=' mt-6 lg:mt-0 text-sm sm:text-base lg:text-sm  '> 
                  <h1 className='border-b-2   w-fit'>RESOURCES </h1>
                 
               <Link to='/privacy'> <p className='mt-2 w-fit hover:text-[#000000]  transition duration-200'> Privacy</p> </Link> 
             <Link to='/terms'>   <p className='mt-2 w-fit hover:text-[#000000]  transition duration-200'>Terms</p> </Link>   
                </div>

                <div className=' mt-6 lg:mt-0 text-sm sm:text-base lg:text-sm' >
                    <h1 className=' w-fit border-b-2'> CONNECT WITH US </h1> 
                    <div className='flex space-x-10 text-xl lg:text-base items-center mt-4'> 
                      <FaFacebookF className='hover:text-[#000000] hover:cursor-pointer transition duration-200'/>
                      <BsTwitter className='hover:text-[#000000]  hover:cursor-pointer transition duration-200'/>
                      <TfiInstagram className='hover:text-[#000000] hover:cursor-pointer transition duration-200'/>
                    </div> 
                </div> 
                </div>


              </div> 
        </div>



        <div className='mt-8 lg:mt-16'> 
            <img className='md:w-full  w-11/12 mx-auto h-1' src='./image/rec.png' alt=''/> 
          </div>

          <div className='container mx-auto  mt-4 pb-4   text-[#ffffff]'> 
              
                  <p className='text-center'> 2022 © MSLockDown </p>
                 
             
            </div>  
      </div> 

    </footer>
  )
}
